import React from "react";
import Select from "react-select";

const SelectExcelSheet = (props) => {
    const { sheetArray, headerin, sindex, setformInput } = props;

    return (
        sheetArray.map((el, index) => (
            <div className="form-group has-field" key={el.fileName + index}>
                <div className="meta-container">
                    <h4 className="meta-heading">Select header and sheet for: {el.fileName}</h4>
                    <label htmlFor={`headerin-${index}`}>Headers in first <span>*</span></label>
                    <div className="flex-container vertical-middle radio-selection">
                        <div className="flexbox half">
                            <label className="custom-input" data-type="radio">
                                Row
                                <input
                                    type="radio"
                                    name={`headerin-${index}`}
                                    value="row"
                                    onChange={(e) => setformInput(e, 'headerin', index)}
                                    checked={headerin[index] === 'row'}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="flexbox half">
                            <label className="custom-input" data-type="radio">
                                Column
                                <input
                                    type="radio"
                                    name={`headerin-${index}`}
                                    value="column"
                                    onChange={(e) => setformInput(e, 'headerin', index)}
                                    checked={headerin[index] === 'column'}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div className="help-text">
                        <label htmlFor={`sheet-index-${index}`}>Select sheet <span>*</span></label>
                        <Select
                            id={`sheet-index-${index}`}
                            className="input-select"
                            value={
                                el.sheets.filter(option => option.value === sindex[index])
                            }
                            isSearchable={true}
                            placeholder="Select sheet of the uploaded excel file"
                            name={`sheet-index-${index}`}
                            options={el.sheets}
                            onChange={(e) => setformInput(e, 'sindex', index)}
                        />
                    </div>
                </div>
            </div>
        ))
    )
};

export default SelectExcelSheet;
